import cn from "classnames";

export const styles = {
  container: cn(
    "hyam-full-width",
    "h-screen",
    "grid grid-cols-12",
    "pl-calc-px-sm",
    "md:pl-calc-px-md",
    "lg:pl-calc-px-lg",
    "xl:pl-calc-px-xl",
    "2xl:pl-calc-px-2xl",
  ),

  col: cn(
    "col-span-3",
    "flex",
    "flex-col",
    "transition-colors",
  ),
  // col 0 centers itself; the child columns anchor to the row of the item that
  // opened them, so their items stay put as the child count changes (AI-47).
  col_centered: cn("justify-center"),
  col_anchored: cn("justify-start"),

  col_content: cn("flex", "flex-col", "gap-2"),

  col_active: cn(
    "bg-hyam-white",
    "border-l",
    "border-gray-200",
  ),
  col_inactive: cn(
    "bg-hyam-black/80",
    "border-hyam-black/80",
  ),

  col_0: cn("col-start-1", "border-l-0"),
  col_1: cn("col-start-4", "pl-10"),
  col_2: cn("col-start-7", "pl-10"),

  col_item: cn("text-left"),
  col_item_button: cn("mb-0"),

  bottom_items_container: cn(
    "flex flex-col fixed bottom-10",
    "pt-8",
  ),

  cta: "mb-28",

  left_edge: cn(
    "bg-hyam-white",
    "absolute",
    "top-0 left-0",
    "h-screen",
    "w-calc-px-sm",
    "md:w-calc-px-md",
    "lg:w-calc-px-lg",
    "xl:w-calc-px-xl",
    "2xl:w-calc-px-2xl",
  ),
  right_edge: cn(
    "bg-hyam-black/80",
    "col-start-10",
    "col-span-3",
  ),

  close_button: cn(
    "absolute",
    "cursor-pointer",
    "top-0",
    "left-calc-px-sm",
    "md:left-calc-px-md",
    "lg:left-calc-px-lg",
    "xl:left-calc-px-xl",
    "2xl:left-calc-px-2xl",
    "h-hyam-navbar-h-sm xl:h-hyam-navbar-h-xl",
    "flex items-center justify-center",
  ),
};

export type HyamPrismicDocumentMenuStyles =
  typeof styles;
